module.exports = __webpack_public_path__ + "static/media/gatsby.aec012ae.svg";